export class NavigationContext {
  periodEndDate: string | null;
  regimeId: number | null;
  registerId: number | null;
  periodStartDate: string | null;
}
